import type {
  ParameterDefinitionCreateOperation,
  ParameterDimensionDefinitionInOut,
} from '@festina/configuration-general-types/configuration'
import { assertNotEmpty, notEmpty } from '@festina-life/core'
import { useCallback } from 'react'

import { useParameterContext } from '../../context/parameterContext'
import { useOperationsContext } from '../../workspace/operationsContext'

export const useUpdateCurrentParameterDefinitionDimension = () => {
  const { parameterDefinitionOperation } = useParameterContext()
  const { onAddOrUpdateOperation } = useOperationsContext()
  assertNotEmpty(parameterDefinitionOperation)

  const { isDraft, internalOperation } = parameterDefinitionOperation

  const update = useCallback(
    async (nextDimension: ParameterDimensionDefinitionInOut) => {
      const nextOperation = {
        ...internalOperation,
        entity: {
          _type: 'ParameterDefinitionInOut',
          ...internalOperation.entity,
          dimensionDefinitions: (
            internalOperation.entity?.dimensionDefinitions ?? []
          )
            .filter(notEmpty)
            .map((dimensionDefinition) =>
              dimensionDefinition.name === nextDimension.name
                ? nextDimension
                : dimensionDefinition,
            ),
        },
      } satisfies ParameterDefinitionCreateOperation

      await onAddOrUpdateOperation({
        operation: nextOperation,
        layer: parameterDefinitionOperation.layer,
        block: parameterDefinitionOperation.block,
        // Irrelevant, you can only edit a dimension from a draft, which can only exist in the workspace.
        shouldOpenUnifiedBranchWorkspace: true,
      })
    },
    [
      internalOperation,
      onAddOrUpdateOperation,
      parameterDefinitionOperation.layer,
      parameterDefinitionOperation.block,
    ],
  )

  return isDraft ? update : undefined
}
